// extracted by mini-css-extract-plugin
export var result = "webform-module--result--227b7";
export var webform_wrapper = "webform-module--webform_wrapper--a428f";